/**
 * Stable colors for active scoring profiles, keyed by their position in the
 * active list. Shared by the profile pills, the matrix "scored by" indicator,
 * and the compare legend so a profile reads as the same color everywhere.
 */
export const PROFILE_COLORS = ["#5A8F63", "#1565C0", "#7B1FA2"];

export function profileColor(index: number): string {
  if (index < 0) return PROFILE_COLORS[0];
  return PROFILE_COLORS[index % PROFILE_COLORS.length];
}
